module.exports = __webpack_public_path__ + "img/vert-1.34ab8284.png";